<div class="site-container">
  @if (showFilters && isMobile()) {
    <app-mobile-filters
      [sortingOptions]="sortingOptions"
      [leadCategoryId]="leadCategory"
      [brands]="brands"
      [brandsLoading]="brandsLoading"
      [(visible)]="mobileFiltersVisible"
      [(selectedCategoryIds)]="selectedCategoryIds"
      [(selectedBrands)]="selectedBrands"
      [(selectedSort)]="selectedSort"
      [(search)]="search"
      (applyFilters)="applyFilters()"
    />
  }

  <div class="grid">
    @if (showFilters && hasCategories && !isMobile()) {
      <div class="col-12 md:col-3 desktop-filters">
        <p-accordion [value]="'1'" [multiple]="false">
          <p-accordion-panel [value]="'1'">
            <p-accordion-header>
              <div class="flex align-items-center gap-2">
                <img
                  src="assets/img/icons/filters/filters.svg"
                  alt="filters"
                  width="20"
                  height="20"
                />
                <span>Filters</span>
              </div>
            </p-accordion-header>
            <p-accordion-content>
              <app-category-filter
                [(selectedCategoryIds)]="selectedCategoryIds"
                [(hasCategories)]="hasCategories"
                [leadCategoryId]="leadCategory"
                (filtersChanged)="applyFilters()"
              />
            </p-accordion-content>
          </p-accordion-panel>
        </p-accordion>
      </div>
    }

    <div [ngClass]="showFilters && hasCategories ? 'col-12 md:col-9' : 'md:col-12'">
      <div class="mb-3">
        <div class="grid">
          <div class="col-12 sm:col-9 desktop-search">
            <span class="block" style="position: relative">
              <i class="pi pi-search input-icon-left"></i>
              <input
                type="text"
                class="search-input"
                pInputText
                placeholder="Search products"
                [style]="{ width: '100%' }"
                [(ngModel)]="search"
                (ngModelChange)="applyFilters()"
              />
            </span>
          </div>
          <div class="col-12 sm:col-3 desktop-sort">
            <p-select
              [options]="sortingOptions"
              [(ngModel)]="selectedSort"
              placeholder="Sort By"
              [style]="{ width: '100%' }"
              [showClear]="true"
              (onChange)="applyFilters()"
            ></p-select>
          </div>
        </div>
      </div>

      <div>
        @if (isLoading) {
          <div
            class="product-grid"
            [ngStyle]="{
              'grid-template-columns': 'repeat(' + productsPerRow + ', 1fr)'
            }"
          >
            @for (skeleton of skeletons; track skeleton) {
              <div>
                <div class="product">
                  <div class="product-price-container">
                    <p-skeleton width="50px" height="16px" borderRadius="12px"></p-skeleton>
                  </div>
                  <div class="image-skeleton">
                    <p-skeleton width="100%" height="208px"></p-skeleton>
                  </div>
                  <div class="flex flex-column align-items-center mt-3">
                    <p-skeleton width="115px" height="16px"></p-skeleton>
                    <p-skeleton width="135px" height="16px"></p-skeleton>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          <div
            class="product-grid"
            [ngStyle]="{
              'grid-template-columns': 'repeat(' + productsPerRow + ', 1fr)'
            }"
          >
            @for (prod of products; track prod.id) {
              <div class="product-item">
                <app-product-item [product]="prod"></app-product-item>
              </div>
            } @empty {
              <div class="col-12" style="grid-column: 1 / -1">
                <p class="text-center text-lg text-500">No products available.</p>
              </div>
              @if (selectedBrands.length && selectedCategories.length) {
                @for (dummy of dummyProducts; track dummy.id) {
                  <div class="product-item">
                    <app-product-item [product]="dummy"></app-product-item>
                  </div>
                }
              }
            }
          </div>
        }
      </div>

      @if (paginatorOptions.last_page > 1) {
        <div class="card flex justify-content-center mt-5">
          <p-paginator
            [first]="paginatorOptions.first"
            [rows]="paginatorOptions.rows"
            [totalRecords]="paginatorOptions.total"
            (onPageChange)="onPageChange($event)"
          />
        </div>
      }
    </div>
  </div>
</div>
